var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[(_vm.linkToMaps)?_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_c('LazyImg',{attrs:{"url":_vm.src,"description":_vm.title}})],1):_c('LazyImg',{attrs:{"url":_vm.src,"description":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }